import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { EaDisplay, EaSize, EaVariant } from '@app/components/pr-display';

@Component({
    selector: 'pr-button',
    templateUrl: './pr-button.component.html',
    styleUrls: ['./pr-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PrButtonComponent {
  @Input() display: EaDisplay;
  @Input() variant: EaVariant = EaVariant.filled;
  @Input() size: EaSize;
  @Input() clazz: string;
  @Input() icon: string;
  @Input() rightIcon: string;
  @Input() leftIcon: string;
  @Input() iconWidth: number = 20;
  @Input() iconHeight: number;
  @Input() iconViewBoxWidth = 20;
  @Input() iconViewBoxHeight = 20;
  @Input() tooltip: string;
  @Input() label: string;
  @Input() type: string = 'button';
  @Input() disabled: boolean = false;
  @Input() mobileIcon: boolean = false;
  @Input() rounded: boolean;

  @Output() onClick: EventEmitter<any> = new EventEmitter();

  constructor() {}

  get hasIcon(): boolean {
    return !!(this.icon || this.leftIcon || this.rightIcon);
  }

  click(event: Event) {
    this.onClick.emit(event);
  }
}
